import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertTriangle, Clock, Users, Brain } from 'lucide-react';
export function PainSection() {
  return <SectionWrapper data-id="element-213">
      <div className="mb-12" data-id="element-214">
        <h2 className="text-3xl md:text-4xl text-white mb-2 font-mono" data-id="element-215">
          <span className="text-cyber-red mr-2" data-id="element-216">{'//'}</span> EL ERROR DEL
          SISTEMA
        </h2>
        <div className="h-1 w-20 bg-cyber-red shadow-neon-red" data-id="element-217"></div>
      </div>

      <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-218">
        Vivir con ansiedad social en 2026 es un{' '}
        <strong className="text-white" data-id="element-219">infierno silencioso</strong>. Es ver cómo
        los demás hacen amigos, consiguen citas y avanzan en la universidad
        mientras tú te quedas atrapado en tu cabeza, sobre-analizando cada
        palabra que dijiste hace tres horas.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-220">
        <div className="bg-cyber-dark p-6 rounded border border-gray-800 hover:border-cyber-red/50 transition-colors" data-id="element-221">
          <Users className="w-8 h-8 text-cyber-red mb-4" data-id="element-222" />
          <p className="text-gray-400" data-id="element-223">
            El terror de que el profesor diga "reúnanse en equipos".
          </p>
        </div>
        <div className="bg-cyber-dark p-6 rounded border border-gray-800 hover:border-cyber-red/50 transition-colors" data-id="element-224">
          <Clock className="w-8 h-8 text-cyber-red mb-4" data-id="element-225" />
          <p className="text-gray-400" data-id="element-226">
            La taquicardia antes de pedir un simple café.
          </p>
        </div>
        <div className="bg-cyber-dark p-6 rounded border border-gray-800 hover:border-cyber-red/50 transition-colors" data-id="element-227">
          <Brain className="w-8 h-8 text-cyber-red mb-4" data-id="element-228" />
          <p className="text-gray-400" data-id="element-229">
            La soledad de estar rodeado de gente pero sentirte a mil kilómetros
            de distancia.
          </p>
        </div>
      </div>

      <div className="bg-cyber-red/10 border border-cyber-red/30 p-8 rounded-lg text-center relative overflow-hidden" data-id="element-230">
        <div className="absolute top-0 left-0 w-full h-1 bg-cyber-red shadow-neon-red" data-id="element-231"></div>
        <h3 className="text-2xl text-white font-mono mb-4" data-id="element-232">
          ¿Cuánto te está costando esto realmente?
        </h3>
        <p className="text-gray-300 mb-0" data-id="element-233">
          ¿Cuántas oportunidades, cuántas relaciones y cuánta paz mental has
          perdido por miedo al juicio de personas que ni siquiera te importan?
          El costo de no hacer nada es quedarte exactamente donde estás hoy:{' '}
          <strong className="text-cyber-red" data-id="element-234">
            solo, frustrado y con miedo al futuro.
          </strong>
        </p>
      </div>
    </SectionWrapper>;
}